import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { Link, useLocation, useNavigate } from "react-router-dom";
//primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
import { TabPanel, TabView } from "primereact/tabview";
//components
import Proxy from "./Proxy/Proxy";
import Owners from "./Owners/Owners";
import Contract from "./Contract/Contract";
import Documents from "./Documents/Documents";
import Signatory from "./Signatory/Signatory";
import Assignment from "./Assignment/Assignment";
import Occurrence from "./Occurrence/Occurrence";
import Cancellation from "./Cancellation/Cancellation";
//components
import Modal from "../../../../../../components/modal/Modal";
import Panel from "../../../../../../components/panel/panel";
import Select from "../../../../../../components/input/Select";
import ModalCard from "../../../../../../components/modal/ModalCard";
//services
import { getSale } from "../../../../../../services/Contracts/getSale";
import { getExistShipping } from "../../../../../../services/GlobalRoles/getExistShipping";
import { listContractModel } from "../../../../../../services/ContractsFiles/listContractModels";
//pages
import ModalStopSale from "./Contract/ModalStopSale";
import Renegotiations from "./Renegotiations/Renegotiations";
import ClickSignDocuments from "./ClickSign/ClickSignDocuments";
import ModalSendIbJuridico from "./IbJuridico/ModalSendIbJuridico";
//context
import { useAppContext } from "../../../../../../context/AppContext";
import usePermission from "../../../../../../hooks/usePermission";
import { postContractVariables } from "../../../../../../services/Enterprise/ClickSign/postContractVariables";

export default function ContractDetails() {
  usePermission("37");

  const form = useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const idSale = location.state.id;
  const id = location.state.enterpriseId;
  const { permissions } = useAppContext();

  const [activeIndex, setActiveIndex] = useState(0);
  const [modalActionsActive, setModalActionsActive] = useState(false);
  const [activeModalContent, setActiveModalContent] = useState(true);
  const [defaultIndexColorActive, setDefaultIndexColorActive] = useState(0);
  const [visibleModalStopSale, setVisibleModalStopSale] = useState(false);
  const [visibleModalSendIbJuridico, setVisibleModalSendIbJuridico] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [typeActionContract, setTypeActionContract] = useState("contrato");
  const [idRenegotiate, setIdRenegotiate] = useState(0);
  const [idAssignment, setIdAssignment] = useState(0);
  const [idCancellation, setIdCancellation] = useState(0);
  const [modelOptions, setModelOptions] = useState([]);

  const { data: contract, isLoading: isLoadingContract } = useQuery({
    queryKey: [`sale${idSale}`],
    queryFn: () => getSale({ id: idSale }),
    enabled: !!permissions?.includes("27"),
  });

  const { data: hasShipping, isLoading: isLoadingShipping } = useQuery({
    queryKey: [`hasShipping${idSale}`],
    queryFn: () => getExistShipping(idSale),
    enabled: !!permissions?.includes("27"),
  });

  const {
    data: documents,
    isLoading: isLoadingDocuments,
    isRefetching: isRefetchingDocuments,
  } = useQuery({
    queryKey: [`documents_${typeActionContract}`],
    queryFn: () =>
      listContractModel({
        enterprise_id: id,
        type_contract: typeActionContract,
      }),
    enabled: !!modalActionsActive || permissions?.includes("109"),
  });

  const items = [
    {
      template: () => (
        <Link
          to={`/negotiations/${location.state.enterpriseId}?type=3`}
          state={{
            name: location.state ? location.state.name : "Empreendimento",
          }}
          className="p-breadcrumb-link"
        >
          Negociações
        </Link>
      ),
    },
    {
      template: () => (
        <Link to="#" state={location.state} className="p-breadcrumb-link">
          Contrato
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const handleModal = async (setSelected) => {
    setSelected(true);
  };

  const actions = [
    ...(permissions && permissions.includes("61")
      ? [
          //Imprimir Contratos
          {
            label: "Imprimir Contratos",
            icon: "pi pi-print",
            command: () => setModalActionsActive(true),
          },
        ]
      : []),

    ...(permissions && permissions.includes("62")
      ? [
          //Enviar para o Juridico
          {
            label: "Enviar para IB Juríidco",
            icon: "fa-solid fa-scale-unbalanced-flip",
            command: () => handleModal(setVisibleModalSendIbJuridico),
          },
        ]
      : []),
    ...(permissions && permissions.includes("63")
      ? [
          //Estornar Contrato
          {
            label: "Estornar Contrato",
            icon: "pi pi-trash",
            command: () => handleModal(setVisibleModalStopSale),
            disabled: hasShipping?.installmentsExistsShipping === true,
            tooltip:
              hasShipping?.installmentsExistsShipping === true
                ? "Para estornar a venda é necessário estornar as remessa em aberto!"
                : "",
          },
        ]
      : []),
  ];

  const modalActions = [
    {
      title: "Contrato",
      icon: "fa-solid fa-file-signature",
      col: "col-md-6 my-2",
      action: () => setTypeActionContract("contrato"),
    },
    ...(idRenegotiate && idRenegotiate > 0
      ? [
          //Alterar Instrução da Parcela
          {
            title: "Renegociação",
            icon: "fa-solid fa-money-bill-transfer",
            col: "col-md-6 my-2",
            action: () => setTypeActionContract("renegociacao"),
          },
        ]
      : []),

    ...(idAssignment && idAssignment > 0
      ? [
          {
            title: "Cessão",
            icon: "fa-solid fa-network-wired",
            col: "col-md-6 my-2",
            action: () => setTypeActionContract("cessao"),
          },
        ]
      : []),
    ...(idCancellation && idCancellation > 0
      ? [
          {
            title: "Distrato",
            icon: "fa-solid fa-network-wired",
            col: "col-md-6 my-2",
            action: () => setTypeActionContract("distrato"),
          },
        ]
      : []),
    ...(contract?.total_open === 0
      ? [
          {
            title: "Quitação",
            icon: "fa-solid fa-hand-holding-dollar",
            col: "col-md-6 my-2",
            action: () => setTypeActionContract("termo_quitacao"),
          },
        ]
      : []),

    // {
    //   title: "Proposta de Compra",
    //   icon: "fa-print",
    //   col: "col-md-6 my-2",
    //   action: () => setTypeActionContract("proposta_compra"),
    // },
  ];

  const handleGenerateContract = async (data) => {
    setIsLoading(true);
    await generateDocument(data.modelToGenerate);
    setModalActionsActive(false);
    setTypeActionContract("contrato");
    setIdRenegotiate(0);
    setIdAssignment(0);
    setIdCancellation(0);
    setDefaultIndexColorActive(0);
    setIsLoading(false);
  };

  const modalContent2 = isLoadingDocuments ? (
    <div className="row pt-5">
      <div className="col-xl-6">
        <Skeleton width="100%" height="40px"></Skeleton>
      </div>
      <div className="col-xl-4">
        <Skeleton width="100%" height="40px"></Skeleton>
      </div>
    </div>
  ) : (
    <div className={`row pt-4`}>
      <div className="col-xl-6">
        <Select
          isRequired={true}
          name="modelToGenerate"
          control={form.control}
          errors={form.errors}
          options={modelOptions}
          label={`Escolha o modelo de ${adjustNomenclatures(
            typeActionContract
          )}`}
        />
      </div>
      <div className="col-xl-4 pt-3 mt-1">
        <Button
          rounded
          type="submit"
          iconPos="right"
          label={"Gerar"}
          icon="fa-solid fa-circle-chevron-right"
          className="p-inputtext-sm m-auto w-100"
          loading={isLoading}
          onClick={form.handleSubmit(handleGenerateContract)}
        />
      </div>
    </div>
  );

  function adjustNomenclatures(tag) {
    let name;
    switch (tag) {
      case "renegociacao":
        name = "Renegociação";
        break;
      case "contrato":
        name = "Contrato";
        break;
      case "proposta_compra":
        name = "Proposta de Compra";
        break;
      case "cessao":
        name = "Cessão";
        break;
      case "distrato":
        name = "Distrato";
        break;
      case "termo_quitacao":
        name = "Quitação";
        break;
      default:
        break;
    }
    return name;
  }

  const generateDocument = async (idDoc) => {
    // console.log(idDoc);
    if (!idDoc) {
      return toast.warning("Selecione um modelo de Contrato");
    }

    let objData;
    if (typeActionContract == "renegociacao") {
      objData = {
        sale_id: idSale,
        file_id: idDoc,
        type: typeActionContract,
        renegotiation_id: idRenegotiate,
      };
    } else if (typeActionContract == "cessao") {
      objData = {
        sale_id: idSale,
        file_id: idDoc,
        type: typeActionContract,
        cession_id: idAssignment,
      };
    } else {
      objData = {
        sale_id: idSale,
        file_id: idDoc,
        type: typeActionContract,
      };
    }

    const notification = toast.loading(
      "Por favor, aguarde o contrato está sendo gerado..."
    );

    try {
      const response = await postContractVariables(objData);
      const { success } = response;

      if (success && success.doc && success.doc.base64) {
        const link = document.createElement("a");
        link.href = success.doc.base64;
        link.download = `${success.doc.name}.docx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.update(notification, {
          render: success?.message || "Contrato gerado com sucesso!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
          theme: "colored",
        });
      } else {
        throw new Error("Dados de contrato inválidos");
      }
    } catch (error) {
      toast.update(notification, {
        render: error?.message || "Não foi possível gerar, tente novamente!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    // if (!isRefetchingDocuments) {
    if (documents && documents.length > 0) {
      const docs = documents.map((d) => ({
        label: d.name,
        value: d.id,
      }));
      setActiveModalContent(true);
      setModelOptions(docs);
    } else if (documents && documents.length === 0 && modalActionsActive) {
      setActiveModalContent(false);
      toast.warning(
        `Não encontramos modelos de ${adjustNomenclatures(
          typeActionContract
        )}, vá até a configuração de modelos de contratos e faça o upload deste arquivo.`
      );
    }
    // }
  }, [documents]);

  useEffect(() => {
    if (location.state?.index >= 0) {
      setActiveIndex(location.state.index);
    }
  }, [location.state]);

  return (
    <>
      <div className="row">
        <div className="col-xl-3">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-xl-9">
          <div className="row justify-content-end pb-3">
            {permissions &&
              permissions.includes("36") && ( //Visualizar Parcelas
                <div className="col-xl-2 col-md-6">
                  <Button
                    label="Parcelas"
                    icon="fa fa-dollar-sign"
                    onClick={() =>
                      navigate(`/enterprise/contracts/parcel`, {
                        state: {
                          id: idSale,
                          enterpriseId: id,
                          enterpriseName: location.state
                            ? location.state.name
                            : "Empreendimento",
                          name_cli: location.state.name_cli,
                          block: location.state.block,
                          land: location.state.land,
                        },
                      })
                    }
                    rounded
                    className="p-inputtext-sm me-2 m-auto w-100"
                  />
                </div>
              )}
            {permissions &&
              permissions.includes("51") && ( //Visualizar Ações do Contrato
                <div className="col-xl-4 col-md-6">
                  <SplitButton
                    rounded
                    label="Ações do Contrato"
                    icon="fa fa-money-check-dollar"
                    className="p-inputtext-sm me-2 m-auto w-100 custom-splitbutton p-button-warning rounded"
                    model={actions.map((action) => ({
                      ...action,
                      template: (item, options) => (
                        <div
                          className={options.className}
                          onClick={action.disabled ? null : options.onClick}
                          data-pr-tooltip={action.tooltip}
                          data-pr-disabled={action.disabled ? true : false}
                          data-pr-position="top"
                        >
                          <i className={options.iconClassName}></i>
                          <span className={options.labelClassName}>
                            {item.label}
                          </span>
                        </div>
                      ),
                    }))}
                    onClick={() => setModalActionsActive(true)}
                  />
                  <Tooltip />
                </div>
              )}
          </div>
        </div>
      </div>
      <ModalCard
        visible={modalActionsActive}
        dynamicTitle={"Geração de Contrato"}
        dynamicContent={modalContent2}
        activeDynamicContent={activeModalContent}
        actions={modalActions}
        onHide={() => {
          setModalActionsActive(false);
          setTypeActionContract("contrato");
          setIdRenegotiate(0);
          setIdAssignment(0);
          setIdCancellation(0);
          setDefaultIndexColorActive(0);
        }}
        colorActive={true}
        defaultIndexColorActive={defaultIndexColorActive}
      />
      <ModalStopSale
        visible={visibleModalStopSale}
        setVisible={setVisibleModalStopSale}
        idSale={idSale}
        enterpriseId={id}
        location={location}
      />
      {permissions?.includes("62") && (
        <ModalSendIbJuridico
          visible={visibleModalSendIbJuridico}
          setVisible={setVisibleModalSendIbJuridico}
          idSale={idSale}
          enterpriseId={id}
          location={location}
        />
      )}
      {isLoadingContract ? (
        <Skeleton width="100%" height="650px" className="my-2"></Skeleton>
      ) : (
        <Panel>
          <TabView
            scrollable
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="meu-tabview"
          >
            {permissions &&
              permissions.includes("37") && ( //Visualizar Resumo do Contrato
                <TabPanel
                  header="Contrato"
                  leftIcon="fa-solid fa-file-signature mx-2"
                >
                  <Contract
                    setActiveIndex={setActiveIndex}
                    id={idSale}
                    contract={contract}
                    isLoadingContract={isLoadingContract}
                    visibleModalStopSale={visibleModalStopSale}
                    setVisibleModalStopSale={setVisibleModalStopSale}
                  />
                </TabPanel>
              )}
            {permissions &&
              permissions.includes("53") && ( //Visualizar Renegociações
                <TabPanel
                  header="Renegociações"
                  leftIcon="fa-solid fa-money-bill-transfer mx-2"
                >
                  <Renegotiations
                    setModalActionsActive={setModalActionsActive}
                    setDefaultIndexColorActive={setDefaultIndexColorActive}
                    setActiveIndex={setActiveIndex}
                    setTypeActionContract={setTypeActionContract}
                    setIdRenegotiate={setIdRenegotiate}
                    id={idSale}
                    enterpriseId={id}
                  />
                </TabPanel>
              )}
            {permissions?.includes("54") && ( //Documentos ClickSign
              <TabPanel
                header="Assinaturas"
                leftIcon="fa-solid fa-file-signature mx-2"
              >
                <ClickSignDocuments
                  setActiveIndex={setActiveIndex}
                  id={idSale}
                />
              </TabPanel>
            )}
            {permissions &&
              permissions.includes("55") && ( //Visualizar Cessão
                <TabPanel
                  header="Cessão"
                  leftIcon="fa-solid fa-network-wired mx-2"
                >
                  <Assignment
                    setIdAssignment={setIdAssignment}
                    id={idSale}
                    cliData={contract && contract.cli}
                    setActiveIndex={setActiveIndex}
                    setModalActionsActive={setModalActionsActive}
                    setDefaultIndexColorActive={setDefaultIndexColorActive}
                    setTypeActionContract={setTypeActionContract}
                    enterpriseId={id}
                  />
                </TabPanel>
              )}
            {permissions &&
              permissions.includes("56") && ( //Visualizar Distrato
                <TabPanel
                  header="Cancelamento"
                  leftIcon="pi pi-chart-line mx-2"
                >
                  <Cancellation
                    setIdCancellation={setIdCancellation}
                    setActiveIndex={setActiveIndex}
                    setModalActionsActive={setModalActionsActive}
                    setDefaultIndexColorActive={setDefaultIndexColorActive}
                    setTypeActionContract={setTypeActionContract}
                    id={idSale}
                    enterpriseId={id}
                  />
                </TabPanel>
              )}
            {permissions &&
              permissions.includes("57") && ( //Visualizar Ocorrências
                <TabPanel
                  header="Ocorrências"
                  leftIcon="fa-solid fa-triangle-exclamation mx-2"
                >
                  <Occurrence setActiveIndex={setActiveIndex} id={idSale} />
                </TabPanel>
              )}
            {permissions &&
              permissions.includes("58") && ( //Visualizar Anexos
                <TabPanel
                  header="Anexos"
                  leftIcon="fa-solid fa-folder-open mx-2"
                >
                  <Documents
                    setActiveIndex={setActiveIndex}
                    id={idSale}
                    cliId={contract.cli.id}
                    enterpriseId={id}
                  />
                </TabPanel>
              )}
            {permissions &&
              permissions.includes("59") && ( //Visualizar Proprietarios
                <TabPanel
                  header="Proprietários"
                  leftIcon="fa-solid fa-users mx-2"
                >
                  <Owners setActiveIndex={setActiveIndex} id={idSale} />
                </TabPanel>
              )}
            {permissions &&
              permissions.includes("60") && ( //Visualizar Procurador
                <TabPanel
                  header="Procurador"
                  leftIcon="fa-solid fa-pen-nib mx-2"
                >
                  <Proxy setActiveIndex={setActiveIndex} id={idSale} />
                </TabPanel>
              )}
            {permissions?.includes("54") &&
              permissions?.includes("78") && ( //Visualizar Signatários no Contrato
                <TabPanel
                  header="Signatários"
                  leftIcon="fa-solid fa-landmark-flag mx-2"
                >
                  <Signatory
                    setActiveIndex={setActiveIndex}
                    id={idSale}
                    enterpriseId={id}
                  />
                </TabPanel>
              )}
          </TabView>
        </Panel>
      )}
    </>
  );
}
